import { render } from "./viewPersonalTraining.html?vue&type=template&id=544ef816&scoped=true&ts=true&external"
import script from "./ViewPersonalTraining.vue?vue&type=script&lang=ts"
export * from "./ViewPersonalTraining.vue?vue&type=script&lang=ts"

import "./ViewPersonalTraining.vue?vue&type=style&index=0&id=544ef816&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544ef816"]])

export default __exports__